<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="eastel-sidebar bg-white print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation?.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full flex-col px-5 pb-5 pt-4">
            <!-- Logo -->
            <div class="eastel-sidebar-logo mb-4 flex items-center justify-center">
                <img src="images/logo/eastel.svg" class="h-11 max-w-40" />
            </div>
            <!-- Components -->
            <!-- <div class="ml-auto flex items-center">
                <notifications></notifications>
            </div> -->

            <!-- MembershipId Selector -->
            @if (userType == 'USER') {
            <div class="w-full pt-4">
                <ng-container fuseVerticalNavigationContent>
                    <membership-selector class="w-full"></membership-selector>
                </ng-container>
            </div>
            }
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="eastel-app-shell flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="eastel-topbar sticky top-0 z-49 flex h-16 w-full flex-0 items-center justify-between px-4 md:px-6 print:hidden">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-label="Toggle navigation">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <user [showAvatar]="false"></user>
    </div>

    <!-- Content -->
    <div class="eastel-content flex h-full w-full flex-row">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <router-outlet></router-outlet>
        }
    </div>
</div>
